var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 160,
    viewBox: "0 0 241 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 248.75,
    height: 168
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_990_52414_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 239.75,
    height: 159,
    rx: 19.5,
    stroke: "#ACACAC",
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.979 68.3112L129.422 58.8101C126.415 56.1032 124.911 54.7498 123.066 54.0417L123.041 61.3337C123.041 67.6191 123.041 70.7618 124.994 72.7144C126.946 74.667 130.089 74.667 136.374 74.667H145.921C144.954 72.7891 143.223 71.2311 139.979 68.3112Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.042 106.667H125.709C135.766 106.667 140.794 106.667 143.918 103.542C147.042 100.418 147.042 95.3898 147.042 85.3333V84.1676C147.042 81.8402 147.042 80.0917 146.929 78.6669H136.376H136.123C133.197 78.6671 130.612 78.6674 128.527 78.3871C126.268 78.0834 124.01 77.386 122.167 75.5426C120.323 73.6993 119.626 71.4407 119.322 69.1817C119.042 67.0976 119.042 64.5121 119.042 61.5865L119.067 54.0281C119.068 53.8083 119.087 53.5908 119.122 53.3777C118.033 53.3333 116.738 53.3333 115.122 53.3333C105.012 53.3333 99.9574 53.3333 96.8332 56.4574C93.709 59.5817 93.709 64.6099 93.709 74.6666V85.3333C93.709 95.3898 93.709 100.418 96.8332 103.542C99.9574 106.667 104.986 106.667 115.042 106.667ZM112.41 82.5407C111.641 81.8197 110.444 81.8197 109.674 82.5407L104.341 87.5407C103.535 88.2962 103.494 89.562 104.25 90.3679C105.005 91.1735 106.271 91.2146 107.077 90.4591L109.042 88.6165V97.3332C109.042 98.4378 109.938 99.3332 111.042 99.3332C112.147 99.3332 113.042 98.4378 113.042 97.3332V88.6165L115.008 90.4591C115.814 91.2146 117.079 91.1735 117.835 90.3679C118.59 89.562 118.549 88.2962 117.744 87.5407L112.41 82.5407Z",
    fill: "#ACACAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_990_52414_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 239.75,
    height: 159,
    rx: 19.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3cf89e5ba11e2903a95178851bed2d20.svg";
export { ForwardRef as ReactComponent };